import { Icon } from '@octano/global-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover, PopoverBody } from 'reactstrap';

import { TranslationsKeys } from '../../../../locales/translations';
import { ActivityTypeHours } from '../api';

interface TotalHoursTooltipProps {
  studyPlanId: number;
  totalHours: number | null;
  activityTypeHours: ActivityTypeHours[];
}

export function TotalHoursTooltip({
  studyPlanId,
  totalHours,
  activityTypeHours,
}: TotalHoursTooltipProps) {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_STUDY_PLANS,
  );

  const [popoverOpen, setPopoverOpen] = useState(false);
  const togglePopover = () => setPopoverOpen(!popoverOpen);

  const popoverId = `total-hours-info-${studyPlanId}`;

  if (!activityTypeHours || activityTypeHours.length === 0) {
    return (
      <span>
        {t('detail.totalHours')}: {totalHours || '-'}
      </span>
    );
  }

  return (
    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
      <span>
        {t('detail.totalHours')}: {totalHours || '-'}
      </span>
      <span
        id={popoverId}
        style={{ cursor: 'pointer', display: 'inline-flex' }}
        onClick={togglePopover}
      >
        <Icon name="information" size="18px" color="primary" />
      </span>
      <Popover
        placement="right"
        isOpen={popoverOpen}
        target={popoverId}
        toggle={togglePopover}
      >
        <PopoverBody>
          <div>
            <strong>{t('detail.totalHour')}</strong>
            <div className="mt-2">
              {activityTypeHours.map((activityHour) => (
                <div key={activityHour.id} className="mb-1">
                  {t('detail.hours')} {activityHour.activityType.name}:{' '}
                  {activityHour.hours}
                </div>
              ))}
            </div>
          </div>
        </PopoverBody>
      </Popover>
    </div>
  );
}
